<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
		<mtipoequipamiento-modals
			:modelName="modelName"
		></mtipoequipamiento-modals>
	</div>
</template>

<script>
import mtipoequipamientoActions from './MtipoequipamientoActions';
import mtipoequipamientoModals from './MtipoequipamientoModals.vue';

export default {
	name: 'mtipoequipamiento-grid',
	components: {
		'mtipoequipamiento-modals': mtipoequipamientoModals
	},
	data() {
		return {
			modelName: 'mtipoequipamiento',
			actions: mtipoequipamientoActions.gridactions,
			modelColumnDefs: {
			}
		}
	}
}
</script>
